import React, { useState, Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Table,
} from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import { withRouter } from "react-router";

import apiResponse from "../../../../services/apiResponse";

import DetailBloc from "./Blocs/DetailBloc";
import moment from "moment";

class IndexView extends Component {
  detailBloc = new DetailBloc();

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.detailBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              detail: response,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    const queryParams = new URLSearchParams(this.props.location.search);
    this.detailBloc.fetchDetail({ uuid: queryParams.get("uuid"), detail: 1 });
  }

  componentWillUnmount() {
    this.detailBloc.detailChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>Detail Exclude Absen</CardTitle>
                  {/* <CardSubtitle className="mb-3">
                                        Informasi Detail Exclude Absen
                                    </CardSubtitle> */}
                  <hr />
                  <Row className="mb-3">
                    <label className="col-md-2">NIP</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .presensi_exclude_absen_employee_nip !== ""
                            ? this.state.detail
                                .presensi_exclude_absen_employee_nip
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "30%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-2">Nama</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .presensi_exclude_absen_employee_nama !== ""
                            ? this.state.detail
                                .presensi_exclude_absen_employee_nama
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "30%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-2">Pangkat/Golongan</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee
                            .employee_current_rank_group_room !== ""
                            ? this.state.detail.employee
                                .employee_current_rank_group_room
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "30%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-2">Jabatan</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee
                            .employee_current_position_name !== ""
                            ? this.state.detail.employee
                                .employee_current_position_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "30%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-2">Unit Kerja</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee
                            .employee_current_work_unit_name !== ""
                            ? this.state.detail.employee
                                .employee_current_work_unit_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "30%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-2">Berlaku Dari</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.presensi_exclude_absen_start_date
                            ? this.state.detail
                                .presensi_exclude_absen_start_date
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "30%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-2">Berlaku Sampai</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.presensi_exclude_absen_end_date
                            ? this.state.detail.presensi_exclude_absen_end_date
                            : "Sekarang"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "30%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="2"></Col>
                    <Col md="9">
                      <Link to="?" className="waves-effect">
                        <Button color="danger">
                          <i className="uil-arrow-left"></i> Kembali
                        </Button>
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
